import * as React from 'react';
import { Navigate, Outlet, Route } from 'react-router-dom';
import { selectLoginStateWaiting, selectUser } from 'gossamer-front-end';
import { useSelector } from 'react-redux';
import { WebsiteAccountLayout } from './AccountLayout';
import { CalendarCombined } from './CalendarCombined';
import { WebsiteAccountCancelledBookingsPage } from './WebsiteAccountCancelledBookingsPage';
import { WebsiteAccountOnDemandEventsPage } from './WebsiteAccountOnDemandEventsPage';
import { WebsiteAccountPortfolioPage } from './WebsiteAccountPortfolioPage';
import { WebsiteAccountProfilePage } from './WebsiteAccountProfilePage';
import { WebsiteAccountUpcomingEventsPage } from './WebsiteAccountUpcomingEventsPage';
import { WebsiteAccountVoucherCodesPage } from './WebsiteAccountVoucherCodesPage';

const ProtectedRoutes = () => {
  const initialising = useSelector(selectLoginStateWaiting);
  const user = useSelector(selectUser);
  if (initialising) {
    return <div>Restoring user session...</div>;
  }
  if (!!user) {
    return <Outlet />;
  }
  return <Navigate to="/auth/login" />;
};

export const getWebsiteAccountRoutes = (): React.ReactNode => (
  <Route element={<ProtectedRoutes />}>
    <Route path="account" element={<WebsiteAccountLayout />}>
      <Route index element={<Navigate to="profile" replace />} />
      <Route path="profile" element={<WebsiteAccountProfilePage />} />
      <Route path="general" element={<Navigate to="../profile" replace />} />
      <Route path="calendar" element={<CalendarCombined />} />
      <Route path="upcoming-events" element={<WebsiteAccountUpcomingEventsPage />} />
      <Route path="on-demand-events" element={<WebsiteAccountOnDemandEventsPage />} />
      <Route path="portfolio" element={<WebsiteAccountPortfolioPage />} />
      <Route path="voucher-codes" element={<WebsiteAccountVoucherCodesPage />} />
      <Route path="cancelled-bookings" element={<WebsiteAccountCancelledBookingsPage />} />
    </Route>
  </Route>
);
